<template>
  <div id="main-block" class="col-md-6">
    <div id="main-block-status" class="col-md-10 mb-4">
      <span v-if="showForbidAccessTitle" id="access">Доступ запрещён</span>
      <span v-if="menuNotEmpty && visitor.personal.isIssued && isView" id="pass-is-issued">Пропуск выдан</span>
      <span v-if="menuNotEmpty && inScud && isPedestrian" id="inSkud">Передан в СКУД</span>
    </div>
    <div v-if="menuNotEmpty && showMenu" id="main-block-menu" class="col-md-2 mb-4">
      <div
        v-click-outside="hide"
        :id="dropDownId"
        class="dropdown application-status-block-button pull-right"
      >
        <a
          :data-toggle="dropDownId"
          class="application-action btn btn-default dropdown-toggle"
          @click="collapse"
        >
          <i class="fa fa-bars"></i>
        </a>
        <ul ref="dropdown" class="dropdown-menu" @click="hide">
          <li>
            <give-access-button
              v-if="visibleCloseButton"
              :visitor="visitor"
              @close-visitor="closeVisitor()"
            />
            <issue-pass-button
              v-if="(visibleVisitorIssuePassButton && isView)"
              title="Выдать пропуск"
              :is-issued="visitor.personal.isIssued"
              @issue-pass="issuePass()"
            />
            <issue-pass-button
              v-if="(visibleVisitorIssuePassPeriodButton && isView)"
              title="Выдать пропуска"
              :is-issued="visitor.personal.isIssued"
              @issue-pass="issuePass()"
            />
            <print-pass-button
              v-if="visibleVisitorPrintPassButton"
              title="Распечатать пропуск"
              @give-pdf-pass="givePdfPass()"
            />
            <print-pass-button
              v-if="visibleVisitorPrintPassPeriodButton"
              title="Распечатать пропуска"
              @give-pdf-pass="givePdfPass(isGivePassPeriod)"
            />
            <print-pass-button
              v-if="visibleVisitorPrintPassPermanentAsOneButton"
              title="Выдать разовый пропуск"
              @give-pdf-pass="givePdfPass(isGivePassPeriod, printPermanentAsOne)"
            />
            <print-pass-button
              v-if="visibleVisitorPrintPassPermanentButton"
              title="Выдать постоянный пропуск"
              @give-pdf-pass="givePdfPass()"
            />
            <send-to-solvo-button
              v-if="visibleVisitorSendToSolvoButton && isView"
              :application-id="form.application.id"
              :personal-id="visitorPersonal.id"
            />
            <send-to-scud-button
              v-if="visibleVisitorSendToScudButton && isView"
              :in-scud="inScud"
              :application-id="form.application.id"
              :personal-id="visitorPersonal.id"
              :visitor="visitor"
              :transport-id="transport.id"
              :require-transport="false"
            />
            <send-to-scud-button
              v-if="visibleVisitorSendToScudButton && isView && transport.type !== TransportTypes.Pedestrian"
              :in-scud="inScud"
              :application-id="form.application.id"
              :personal-id="visitorPersonal.id"
              :visitor="visitor"
              :transport-id="transport.id"
            />
            <QrScudButton
              v-if="visibleVisitorQrScudButton && isView"
              :application-id="form.application.id"
              :personal-id="visitorPersonal.id"
              @show-qr-code="showQrCode"
            />
          </li>
        </ul>

        <div v-if="showQrModal" class="qr-modal-overlay" @click="closeQrModal">
          <div class="qr-modal" @click.stop>
            <h3>QR-код посетителя</h3>
            <img v-if="qrCode" :src="qrCode" alt="QR код" class="qr-image" />
            <p v-else>Загрузка...</p>
            <button @click="closeQrModal" class="btn btn-secondary">Закрыть</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import applicationFormContextMixin from '../../../../mixins/applicationFormContextMixin'
import mainMixin from '../../../../mixins/mainMixin'
import forceRerenderMixin from '../../../../mixins/forceRerenderMixin'
import { ApiClient } from '@/helpers/api-client/ApiClient'
import sendToSolvoButton from './menu-items/SendToSolvoButton'
import sendToScudButton from './menu-items/SendToScudButton.vue'
import GiveAccessButton from './menu-items/GiveAccessButton'
import PrintPassButton from './menu-items/PrintPassButton'
import IssuePassButton from './menu-items/IssuePassButton'
import visitorBlockMixin from '../../../../mixins/application-form/visitorBlockMixin'
import '@/common/assets/styles/visitor-menu-style.scss'
import { ConfigMenuNames } from '@/common/enums/ConfigMenuNames'
import { TransportTypes } from '@/common/enums/TransportTypes'
import QrScudButton from '@/common/components/application/form-blocks/visitors/menu-items/QrScudButton.vue'

export default {
  name: 'VisitorFormMenu',

  components: {
    QrScudButton,
    sendToSolvoButton,
    sendToScudButton,
    GiveAccessButton,
    PrintPassButton,
    IssuePassButton
  },

  directives: {
    ClickOutside
  },

  mixins: [
    applicationFormMixin,
    applicationFormContextMixin,
    mainMixin,
    visitorBlockMixin,
    forceRerenderMixin
  ],

  model: {
    prop: 'visitorPersonal',
    event: 'change-visitor'
  },

  props: {
    cfgMenuVisitor: {
      type: [Object, Array],
      default: () => []
    },

    isSingleVisitor: {
      type: Boolean,
      required: true
    },

    visitor: {
      type: Object,
      default: () => ({})
    },

    visitorIndex: {
      type: Number,
      required: true
    },

    visitorPersonal: {
      type: Object,
      required: true
    },

    menuNotEmpty: {
      type: Boolean
    }
  },

  data: () => {
    return {
      status: null,
      baseUrl: process.env.VUE_APP_API_BASE_URL,
      showQrModal: false,
      qrCode: null
    }
  },

  computed: {
    TransportTypes() {
      return TransportTypes
    },

    isGivePassPeriod() {
      return !!this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_PERIOD]
    },

    printPermanentAsOne() {
      return Boolean(this.cfgMenuVisitor[ConfigMenuNames.GIVE_PASS_ONE])
    },

    dropDownId() {
      return `visitor-dropdown-${this.visitorIndex}`;
    },

    inScud() {
      return Boolean(this.visitor?.transports[0]?.inScud)
    },

    showMenu() {
      return Array.isArray(this.cfgMenuVisitor) === false || this.visibleCloseButton || this.isView === false
    },

    transport() {
      return this.visitor.transports[0]
    },

    showForbidAccessTitle() {
      return this.isView && this.visitor.access
    }
  },

  methods: {
    async closeVisitor() {
      await ApiClient.changeVisitorAccess({
        visitor_id: this.visitorPersonal,
        appId: this.form.application.id
      }).then((response) => {
        if (response?.data?.status === 'success') {
          const indexOf = this.approveForm.visitors.indexOf(~~this.visitorPersonal.id)

          if (indexOf === -1) {
            this.approveForm.visitors.push(~~this.visitorPersonal.id)
          } else {
            this.approveForm.visitors.splice(indexOf, 1)
          }

          this.$set(this.visitor, 'access', this.visitor.access ? 0 : 1)
          this.visitor.transports.forEach(element => { element.access = this.visitor.access });
        }
      })
    },

    collapse() {
      let el = document.getElementById(this.dropDownId)
      if (el) {
        el.classList.toggle('open')
      }
    },

    hide() {
      let el = document.getElementById(this.dropDownId)
      if (el) {
        el.classList.remove('open')
      }
    },

    async issuePass() {
      await ApiClient.issuePass({
        visitor_id: this.visitor.personal.id,
        appId: this.form.application.id
      }).then((result) => {
        if (result && result.data.status === 'success') {
          this.visitor.personal.isIssued = true
          this.givePdfPass(this.isGivePassPeriod)
        }
      }).catch(function () {
        alert('Не удалость выдать пропуск.');
      });
    },

    showQrCode(event, qrCode) {
      event.preventDefault()
      this.showQrModal = true
      this.qrCode = qrCode
    },

    closeQrModal() {
      this.showQrModal = false
      this.qrCode = null
    }
  }
}
</script>
